// FILE: src/services/importStoreMerge.js
//
// How a bulk import updates the in-memory question store for one cert.
//
// A store slot is either null (bank not loaded in this tab) or the FULL bank.
// Every consumer treats a non-null slot as authoritative and complete: the
// session draw uses it instead of loading the bank, and the Question Editor
// skips its own load. So an import must never turn a null slot into a slot
// holding only the imported rows — that made the next practice session draw
// from just those rows (all status 'new', so none eligible) and fail with
// "No questions are available for this session right now".
//
//   null store     → stays null; the next consumer loads the real bank,
//                    which now includes the saved rows (caller invalidates
//                    the cert's bank cache).
//   loaded store   → append rows whose id is not already present (re-importing
//                    after a refresh must not duplicate approved questions).
//
// Pure; unit-tested in importStoreMerge.test.js.

/**
 * @param {any[]|null|undefined} prevStore
 * @param {any[]} importedQuestions
 * @returns {any[]|null} the next store value (=== prevStore when unchanged)
 */
export function mergeImportIntoStore(prevStore, importedQuestions) {
  if (prevStore == null) return prevStore ?? null;
  const incoming = Array.isArray(importedQuestions) ? importedQuestions : [];
  const existingIds = new Set(prevStore.map((q) => String(q.id)));
  const genuinelyNew = incoming.filter((q) => q && !existingIds.has(String(q.id)));
  return genuinelyNew.length === 0 ? prevStore : [...prevStore, ...genuinelyNew];
}
